import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const colorMap: Record<string, { bg: string; border: string; iconBg: string; iconColor: string }> = {
  primary: { bg: 'bg-primary-50', border: 'border-primary-200/60', iconBg: 'bg-primary-100', iconColor: 'text-primary-600' },
  accent: { bg: 'bg-accent-50', border: 'border-accent-200/60', iconBg: 'bg-accent-100', iconColor: 'text-accent-600' },
  secondary: { bg: 'bg-secondary-50', border: 'border-secondary-200/60', iconBg: 'bg-secondary-100', iconColor: 'text-secondary-600' },
};

export default function CategoryCards() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            内容分类导航
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            按主题浏览我们的内容，从风险警示到健康替代方案，全方位守护您的数字生活。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat) => {
            const colors = colorMap[cat.color] || colorMap.primary;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`${colors.bg} border ${colors.border} rounded-xl p-6 transition-all duration-300 hover:-translate-y-1.5 cursor-pointer group`}
              >
                <div className={`w-12 h-12 rounded-xl ${colors.iconBg} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${cat.icon} text-2xl ${colors.iconColor}`}></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 text-base mb-2">{cat.name}</h3>
                <p className="text-foreground-600 text-sm leading-relaxed mb-3">{cat.description}</p>
                <div className="flex items-center justify-between">
                  <span className="text-foreground-500 text-xs">{cat.articleCount} 篇文章</span>
                  <span className={`${colors.iconColor} text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300`}>
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}